import { usePageSeo } from "@/hooks/usePageSeo";
import { useLang } from "@/context/LanguageContext";
import { PageHero } from "@/components/common/PageHero";
import { MarketCard } from "@/components/common/MarketCard";
import { CTASection } from "@/components/common/CTASection";
import { CircleDollarSign, Boxes, BarChart3, Building } from "lucide-react";

const ICONS = [CircleDollarSign, Boxes, BarChart3, Building];
const LINKS = ["/markets/forex", "/markets/commodities", "/markets/indices", "/markets/shares"];

export default function Markets() {
  const { L } = useLang();
  const P = L.pages.markets;
  usePageSeo("markets");
  return (
    <>
      <PageHero
        overline={P.overline}
        title={P.title}
        description={P.desc}
        breadcrumbs={[{ label: L.common.home, to: "/" }, { label: P.overline }]}
      />
      <section className="py-20 lg:py-28">
        <div className="container-tight grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {L.marketAccess.cards.map((c, i) => (
            <MarketCard key={i} icon={ICONS[i]} title={c[0]} description={c[1]} cta={c[2]} to={LINKS[i]} />
          ))}
        </div>
      </section>
      <CTASection />
    </>
  );
}
